import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "col-lg-7 col-md-7 col-sm-12 col-12" }, [
  /*#__PURE__*/_createVNode("div", { class: "custom-input-group mb-3" })
], -1)
const _hoisted_3 = { class: "col-lg-5 col-md-5 col-sm-12 col-12 text-right" }
const _hoisted_4 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sky btn-sm"
}, [
  /*#__PURE__*/_createTextVNode(" Create New Commercial Group "),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" No commercial groups. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Loading commercial groups data. Please wait. ")
const _hoisted_7 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sm btn-primary ml-1"
}, [
  /*#__PURE__*/_createTextVNode(" Edit "),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-pen",
    style: {"font-size":"12px"}
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sm btn-success ml-1"
}, [
  /*#__PURE__*/_createTextVNode(" Customers "),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-users",
    style: {"font-size":"12px"}
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Details ")
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fas fa-search fa-sm" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "table text-left details-table"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("td", {
  class: "table-list-header",
  style: {"border-top-width":"0","padding-top":"0"}
}, " Commercial Group Id ", -1)
const _hoisted_13 = {
  class: "table-list-value",
  style: {"border-top-width":"0","padding-top":"0"}
}
const _hoisted_14 = /*#__PURE__*/_createVNode("td", {
  class: "table-list-header",
  style: {"border-top-width":"0","padding-top":"0"}
}, " Name ", -1)
const _hoisted_15 = {
  class: "table-list-value",
  style: {"border-top-width":"0","padding-top":"0"}
}
const _hoisted_16 = /*#__PURE__*/_createVNode("td", {
  class: "table-list-header",
  style: {"border-top-width":"0","padding-top":"0"}
}, " Description ", -1)
const _hoisted_17 = {
  class: "table-list-value",
  style: {"border-top-width":"0","padding-top":"0"}
}
const _hoisted_18 = /*#__PURE__*/_createVNode("td", {
  class: "table-list-header",
  style: {"border-top-width":"0","padding-top":"0"}
}, " Default Spread ", -1)
const _hoisted_19 = {
  class: "table-list-value",
  style: {"border-top-width":"0","padding-top":"0"}
}
const _hoisted_20 = /*#__PURE__*/_createVNode("td", {
  class: "table-list-header",
  style: {"border-top-width":"0","padding-top":"0"}
}, " Created At ", -1)
const _hoisted_21 = {
  class: "table-list-value",
  style: {"border-top-width":"0","padding-top":"0"}
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" No plan pairs for this Commercial group. ")
const _hoisted_23 = {
  key: 0,
  class: "badge badge-pill badge-secondary"
}
const _hoisted_24 = {
  key: 1,
  class: "badge badge-pill badge-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Modal = _resolveComponent("Modal")
  const _component_CardBase = _resolveComponent("CardBase")

  return (_openBlock(), _createBlock(_component_CardBase, { title: "Commercial Groups" }, {
    default: _withCtx(() => [
      _createVNode("div", null, [
        _createVNode(_component_DataTable, {
          value: _ctx.commercialGroups,
          paginator: true,
          rows: 10,
          rowsPerPageOptions: [10, 20, 50],
          autoLayout: true,
          loading: _ctx.status == 'fetching',
          paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
          currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
        }, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, { to: { name: 'CommercialGroups.create' } }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _hoisted_5
          ]),
          loading: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "id",
              header: "Id"
            }),
            _createVNode(_component_Column, {
              field: "name",
              header: "Name"
            }),
            _createVNode(_component_Column, {
              field: "description",
              header: "Description"
            }),
            _createVNode(_component_Column, {
              field: "defaultSpread",
              header: "Default Spread",
              bodyClass: "text-right"
            }),
            _createVNode(_component_Column, { header: "Created At" }, {
              body: _withCtx(({data}) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(data.createdAt)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Actions",
              headerStyle: "text-align:center",
              bodyClass: "text-right"
            }, {
              body: _withCtx(({data}) => [
                _createVNode("div", null, [
                  _createVNode(_component_router_link, {
                    to: {
                  name: 'CommercialGroups.edit',
                  params: { id: data.id }
                }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {
                  name: 'CommercialGroups.customers',
                  params: { id: data.id }
                }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-outline-info btn-sm ml-1",
                    onClick: 
                  () => {
                    _ctx.selectedPlan = data
                    _ctx.showModal = true
                  }
                
                  }, [
                    _hoisted_9,
                    _hoisted_10
                  ], 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ]),
      _createVNode(_component_Modal, {
        show: _ctx.showModal,
        onOk: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = false)),
        title: 'Plan #' + _ctx.selectedPlan?.id + ' Details',
        showCancelButton: false,
        okText: "Close",
        okButtonClass: "btn-secondary"
      }, {
        default: _withCtx(() => [
          (_ctx.selectedPlan)
            ? (_openBlock(), _createBlock("table", _hoisted_11, [
                _createVNode("tr", null, [
                  _hoisted_12,
                  _createVNode("td", _hoisted_13, _toDisplayString(_ctx.selectedPlan.id), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_14,
                  _createVNode("td", _hoisted_15, _toDisplayString(_ctx.selectedPlan.name), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_16,
                  _createVNode("td", _hoisted_17, _toDisplayString(_ctx.selectedPlan.description), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_18,
                  _createVNode("td", _hoisted_19, _toDisplayString(_ctx.selectedPlan.defaultSpread), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_20,
                  _createVNode("td", _hoisted_21, _toDisplayString(_ctx.formatDate(_ctx.selectedPlan.createdAt)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", null, [
            _createVNode(_component_DataTable, {
              value: _ctx.selectedPlan.planPairs,
              autoLayout: true,
              rowClass: _ctx.rowClass,
              scrollable: true,
              scrollHeight: "240px"
            }, {
              empty: _withCtx(() => [
                _hoisted_22
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "pairId",
                  header: "Pair",
                  bodyStyle: "text-align: left"
                }),
                _createVNode(_component_Column, {
                  field: "spread",
                  header: "Spread",
                  bodyStyle: "text-align: right"
                }),
                _createVNode(_component_Column, {
                  header: "Explicit",
                  bodyClass: "text-right"
                }, {
                  body: _withCtx(({data}) => [
                    (data.id == null)
                      ? (_openBlock(), _createBlock("span", _hoisted_23, "NO"))
                      : (_openBlock(), _createBlock("span", _hoisted_24, "YES"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "rowClass"])
          ])
        ]),
        _: 1
      }, 8, ["show", "title"])
    ]),
    _: 1
  }))
}